import { Col, Input, Row, Select } from 'antd'
import React, { useState } from 'react';
import moment from 'moment';
const { Option } = Select;

const AbhaLinkedFilter = ({ searchHide, filter, setFilter, setPage, setOffset = (val) => { } }) => {
    const [values, setValues] = useState({
        searchString: "",
        fromDate: "",
        toDate: "",
    })

    const handleChange = (name, value) => {
        setValues({ ...values, [name]: value });
    }
    const handleFilter = () => {
        setFilter({ ...filter, ...values });
        setPage(1);
        setOffset(0);
    }
    const handleFilterReset = () => {
        setFilter({});
        setValues({
            ...values,
            searchString: "",
            fromDate: "",
            toDate: "",
        })
        setPage(1);
    }
// console.log(values)
    return (

        <div className='table_filter'>
            <Row gutter={[24, 20]} className="ml-10">

                <Col md={5} sm={12} xs={24}>

                    <strong>  <p className='mb-2'>From Date</p></strong>
                    <Input

                        type="date"
                        id="fromdate"
                        autoComplete="off"
                        className='form-control'
                        onChange={(e) => handleChange("fromDate", e.target.value)}
                        max={moment().format("YYYY-MM-DD")}
                        placeholder='From Date'
                        value={values?.fromDate}
                    />

                </Col>

                <Col md={5} sm={12} xs={24}>
                    <strong><p className='mb-2'>To Date</p></strong>
                    <Input
                        type="date"
                        id="todate"
                        autoComplete="off"
                        className='form-control'
                        onChange={(e) => handleChange("toDate", e.target.value)}
                        min={values?.fromDate}
                        placeholder='To Date'
                        value={values?.toDate}
                    />
                </Col>
                {!searchHide &&
                    <Col md={6} sm={4} xs={24}>
                        <strong> <p className='mb-2'>Search</p></strong>
                        <Input
                            type="text"
                            autoComplete="off"
                            className='form-control'
                            onChange={(e) => handleChange("searchString", e.target.value)}
                            placeholder='Name or Abha address'
                            value={values?.searchString}
                        />
                    </Col>}
                <Col md={3} sm={12} xs={24}>
                    <div className='flex gap10 mt-20'>
                        <button className='filter-button' onClick={() => handleFilter()}>Filter</button>
                        <button className='clear-button' onClick={() => handleFilterReset()}>Reset</button>
                    </div>
                </Col>
            </Row>
        </div >
    )
}

export default AbhaLinkedFilter